 <!-- 设置页面 -->
<template>
  <div class="user-wrap">
    <common-head title="设置" />
    <div class="setting-tab">
        <van-row class="setting-row">
          <van-col span="24">
            <div class="setting-title">下载安装路径</div>
            <div class=" setting-content">{{defaultAddress}}(默认地址不可修改）</div>
          </van-col>
        </van-row>
    </div>
    <div class="setting-tab">
        <van-row class="setting-row"  @click="checkUpdate">
          <van-col span="16">
            <div class="setting-title">检查更新</div>
          </van-col>
        </van-row>
        <van-row class="setting-row" @click="jumpAbout">
          <van-col span="16">
            <div class="setting-title">关于</div>
          </van-col>
        </van-row>
    </div>
  </div>
</template>
<script>
import CommonHead from 'components/CommonHead'
export default {
  name:'User',
  components: {
    CommonHead
  },
  data() {
    return {
      defaultAddress:''
    }
  },
  created() {
    this.getDefaultAddress()
  },
  methods: {
    jumpAbout(){
      this.$router.push("/about");
    },
    getDefaultAddress(){
      this.defaultAddress =  window.AndroidWebView.getDefaultAddress();
    },
    checkUpdate(){
      window.AndroidWebView.checkUpdate()
    }
  }
}
</script>
<style lang="less" scoped>
.setting-tab {
  margin-bottom: 6.5px;
  .setting-row {
    border-bottom: 1px solid #f6f8fa;
    padding: 10px 16px;
    background-color: #fff;
    .setting-title {
      font-size: 14px;
      font-weight: bold;
      color: #272E45;
      height: 20px;
      line-height: 20px;
    }
    .setting-content {
      height: 17px;
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      line-height: 17px;
    }
  }
}


</style>